import React from "react";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import * as Yup from "yup";

import Error from "../../components/error";
import SuccessMsg from "../../components/successMsg";
import Button from "../../components/button";
import ICInput from "../../components/form/input";

import { pinRegex } from "../../constants/constants";

const ChangePinFormSchema = Yup.object({
  oldPin: Yup.string()
    .required("Please enter Old PIN")
    .min(4, "Minimum 4 numbers are required")
    .max(4, "Maximum 4 numbers are allowed")
    .matches(pinRegex, "Please enter valid PIN(space and ' are not allowed)"),
  newPin: Yup.string()
    .required("Please enter New PIN")
    .min(4, "Minimum 4 numbers are required")
    .max(4, "Maximum 4 numbers are allowed")
    .matches(pinRegex, "Please enter valid PIN(space and ' are not allowed)"),
  confirmNewPin: Yup.string()
    .required("Please Confirm PIN")
    .oneOf([Yup.ref("newPin")], "Both PIN should match")
});

const ChangePinForm = props => {
  const formik = useFormik({
    initialValues: {
      oldPin: "",
      newPin: "",
      confirmNewPin: ""
    },
    validationSchema: ChangePinFormSchema,
    onSubmit: values => {
      props.onFormSubmit(values);
    }
  });
  return (
    <form className="w-100" onSubmit={formik.handleSubmit}>
      <h4 className="mb-4">Change PIN</h4>
      <div className="form-group row mt-4">
        <label className="col-sm-3 col-form-label pb-0">
          Old PIN: <span className="error">*</span>
        </label>
        <div className="col-sm-6">
          <ICInput
            name="oldPin"
            type="password"
            value={formik.values.oldPin}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.oldPin && formik.errors.oldPin ? true : false}
            helperText={
              formik.touched.oldPin && formik.errors.oldPin
                ? formik.errors.oldPin
                : ""
            }
          />
        </div>
      </div>
      <div className="form-group row mt-4">
        <label className="col-sm-3 col-form-label">
          New PIN: <span className="error">*</span>
        </label>
        <div className="col-sm-6">
          <ICInput
            name="newPin"
            type="password"
            value={formik.values.newPin}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.newPin && formik.errors.newPin ? true : false}
            helperText={
              formik.touched.newPin && formik.errors.newPin
                ? formik.errors.newPin
                : ""
            }
          />
        </div>
      </div>
      <div className="form-group row mt-4">
        <label className="col-sm-3 col-form-label">
          Confirm New PIN: <span className="error">*</span>
        </label>
        <div className="col-sm-6">
          <ICInput
            name="confirmNewPin"
            type="password"
            value={formik.values.confirmNewPin}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.confirmNewPin && formik.errors.confirmNewPin
                ? true
                : false
            }
            helperText={
              formik.touched.confirmNewPin && formik.errors.confirmNewPin
                ? formik.errors.confirmNewPin
                : ""
            }
          />
        </div>
      </div>
      <br />
      <div className="d-flex flex-row flex-wrap">
        <Button className="mb-4" title="Reset" type="submit" />
      </div>
      <Error>{props.serverErrorMsg}</Error>
      <SuccessMsg>{props.successMsg}</SuccessMsg>
    </form>
  );
};

export default ChangePinForm;

ChangePinForm.defaultProps = {
  serverErrorMsg: "",
  successMsg: ""
};

ChangePinForm.propTypes = {
  onFormSubmit: PropTypes.func,
  serverErrorMsg: PropTypes.string,
  successMsg: PropTypes.string
};
